import styles from '@/components/ui/skeletons/EVsListItemVariantSkeleton.module.css'

const EVsListItemVariantSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.picture}>
        <div className={styles.imageSkeleton} />
      </div>
      <div className={styles.group1}>
        <div className={styles.nameSkeleton} />
        <div className={styles.variantSkeleton} />
      </div>
      <div className={styles.attributesSkeleton}>
        <div className={styles.attributeSkeleton} />
        <div className={styles.attributeSkeleton} />
        <div className={styles.attributeSkeleton} />
        {/*<div className={styles.attributeSkeleton}/>*/}
        <div className={styles.attributeSkeleton} />
        <div className={styles.attributeSkeleton} />
        <div className={styles.attributeSkeleton} />
      </div>
    </div>
  )
}

export default EVsListItemVariantSkeleton
